import { slugify } from "./slugyfy";

export const searchCategory = (list) => {

  const splitUrl = window.location.href.split('/').filter(Boolean);
  const currentCategory = splitUrl[3];
  const CategorySlug = splitUrl[2];
  const homeUrl = window.location.origin;

  list.value= slugify(currentCategory);

  list.addEventListener('change', (e) =>{
    const newCategorySlug = slugify(e.target.value);
    const newUrl = `${homeUrl}/${CategorySlug}/${newCategorySlug}`;
    console.log(newUrl);
    window.location.href = newUrl;
  })
  
}
